import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import shareImg from '../images/shareIcon.svg';
import blackHeart from '../images/blackHeartIcon.svg';

function FavoriteFoodCard(props) {
  const { recipe, index, favoriteRecipes, setFavoriteRecipes } = props;
  const { id, name, image, category, nationality } = recipe;
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    const time = 2500;
    navigator.clipboard.writeText(`http://localhost:3000/foods/${id}`);
    setCopied(true);
    setTimeout(() => setCopied(false), time);
  };

  const handleUnfavorite = () => {
    const newFavorites = [...favoriteRecipes];
    newFavorites.splice(favoriteRecipes.indexOf(recipe), 1);
    localStorage.setItem('favoriteRecipes', JSON.stringify(newFavorites));
    setFavoriteRecipes(newFavorites);
  };

  return (
    <div className="f-recipe-card">
      <Link to={ `/foods/${id}` }>
        <img
          data-testid={ `${index}-horizontal-image` }
          className="f-recipe-img"
          alt={ name }
          src={ image }
          width="200px"
        />
      </Link>
      <div className="f-recipe-details">
        <Link to={ `/foods/${id}` }>
          <h1 data-testid={ `${index}-horizontal-name` } className="f-recipe-title">
            {name}
          </h1>
        </Link>
        <h3 data-testid={ `${index}-horizontal-top-text` } className="f-infos">
          { `${nationality} - ${category}` }
        </h3>
        <div className="f-details-buttons">
          <button
            type="button"
            data-testid={ `${index}-horizontal-share-btn` }
            className="f-share-btn"
            src={ shareImg }
            onClick={ handleClick }
          >
            <img src={ shareImg } alt="share" />
          </button>
          <button
            type="button"
            data-testid={ `${index}-horizontal-favorite-btn` }
            className="f-favorite-btn"
            onClick={ handleUnfavorite }
            src={ blackHeart }
          >
            <img src={ blackHeart } alt="unfavorite" />
          </button>
        </div>
        {
          copied && <p className="f-copied">Link copied!</p>
        }
      </div>
    </div>
  );
}

FavoriteFoodCard.propTypes = {
  recipe: PropTypes.object,
  index: PropTypes.string,
  favoriteRecipes: PropTypes.array,
  setFavoriteRecipes: PropTypes.func,
}.isRequired;

export default FavoriteFoodCard;
